import React from 'react'
import { connect } from 'react-redux'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import LinearProgress from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import { getRecentPoliciesRequest } from '../../../components/RecentPolicies/Redux/actions'
import { getAgentGuid } from '../../../lib/access.es6'
import AgentPoliciesTable from './Components/AgentPoliciesTable'
import {
  NEW_BUSINESS,
  PORTFOLIO,
  agentPolicyFilter,
  selectAgentPolicies
} from './lib/agentPolicies'

const TITLES = {}
TITLES[NEW_BUSINESS] = 'New Business'
TITLES[PORTFOLIO] = 'Portfolio'

const SUBTITLES = {}
SUBTITLES[NEW_BUSINESS] = 'Business you have submitted that is not yet accepted.'
SUBTITLES[PORTFOLIO] = 'Every policy you have onboarded that has been accepted.'

// An agent's own book of business, split into the two headers the distribution
// brief asks for.
//
// SCOPING: the engine narrows the set to this agent — the request carries
// additional_details.agent_guid, so another agent's policies never reach the
// browser at all. selectAgentPolicies re-checks the same guid on the way to the
// table as a second line of defence, not as the primary control.

export class AgentPolicies extends React.Component {
  componentDidMount() {
    this.load()
  }

  load() {
    // Nothing can be matched to a login the journeys never stamped, so the
    // fetch would be pure waste — and an unscoped request for every partner
    // policy is exactly what must not happen.
    if (!this.props.agentGuid) {
      return
    }
    // fetchAll, because the two views are split by status client-side and so
    // have no server-side page or total of their own — the table has to hold
    // the whole matching set to count and paginate it. That set is one agent's
    // book, not the partner's. Same mechanism as OMM's Need Action tab.
    this.props.dispatch(
      getRecentPoliciesRequest({
        fetchAll: true,
        page: 1,
        size: 20,
        ...agentPolicyFilter(this.props.agentGuid)
      })
    )
  }

  view() {
    const params = this.props.params || {}
    return params.view === PORTFOLIO ? PORTFOLIO : NEW_BUSINESS
  }

  render() {
    const view = this.view()
    const data = this.props.recentPoliciesData || {}

    // An is_agent login with no guid would otherwise get an empty table
    // reading as "you have sold nothing".
    if (!this.props.agentGuid) {
      return (
        <Box sx={{ p: 2 }}>
          <Alert severity="info">
            This login is not linked to an agent record, so no policies can be
            matched to you.
          </Alert>
        </Box>
      )
    }

    const policies = selectAgentPolicies(
      data.policies,
      view,
      this.props.agentGuid
    )

    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="h5">{TITLES[view]}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {SUBTITLES[view]}
        </Typography>

        {/* The rows already fetched are usable; this covers the slices still
            streaming in behind them. */}
        {data.loadingMore ? <LinearProgress sx={{ mb: 1 }} /> : null}

        <AgentPoliciesTable
          view={view}
          policies={policies}
          loading={!!data.loader}
        />
      </Box>
    )
  }
}

export default connect(function(state) {
  return {
    recentPoliciesData: state.recentPoliciesData,
    agentGuid: getAgentGuid()
  }
})(AgentPolicies)
